import React, { useEffect, useContext } from "react";
import { Segment, Tab } from "semantic-ui-react";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { useParams } from "react-router-dom";
import ActionHistory from "./ActionHistory";
import GraphicRepresentation from "./GraphicRepresentation";
import XML from "./XML";
import { sectionsInvoice } from "../../../app/util/breadcrumbOptions";
import { RootStoreContext } from "../../../app/stores/rootStore";
import General from "./General";
import NotificationHistory from "./NotificationHistory";


const DashboardInvoice: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { clearInvoice, getDocumentById } = rootStore.invoiceStore;

  const {id, invoiceName, tab} = useParams();


  useEffect(() => {
    clearInvoice();
    getDocumentById(id);
  }, [clearInvoice, getDocumentById, id]);

  const panes = [
    {
      menuItem: "Información General",
      render: () => (
        <Tab.Pane>
          <General/>
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Representación Gráfica",
      render: () => (
        <Tab.Pane>
          <GraphicRepresentation id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "XML",
      render: () => (
        <Tab.Pane>
          <XML id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Historial de Acciones",
      render: () => (
        <Tab.Pane>
          <ActionHistory id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Historial de Notificaciones",
      render: () => (
        <Tab.Pane>
          <NotificationHistory id={id}/>
        </Tab.Pane>
      ),
    },
  ];
  document.title = `Detalle ${invoiceName}`;
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title={`Detalle ${invoiceName}`}
        sections={sectionsInvoice}
      />
      <Segment>
        <div className="configurationContent">
          <Tab defaultActiveIndex={tab} panes={panes} />
        </div>
      </Segment>
    </div>
  );
};

export default DashboardInvoice;
